/** عناصر التنقّل الـ13 — الترتيب والتقسيم منسوخين من design/Main.dc.html */
import type { IconName } from "./Icon";
import { matchRoute } from "@/lib/router";
// ⚠️ حارس أسماء الشرايح — بيتستورد من هنا **عمدًا** لأن `Shell` بيستورد
//    الملف ده في كل شاشة. حارس في موديول محدش مستورده = سطر ميت.
import { CHIP_NAME_CLASHES } from "@/lib/chip-labels";

export type NavEntry = { key: string; label: string; icon: IconName; path: string };
export type NavGroup = { label: string | null; items: NavEntry[] };

export const NAV_GROUPS: NavGroup[] = [
  {
    label: null,
    items: [
      { key: "desk", label: "مكتبي", icon: "desk", path: "/desk" },
      { key: "team", label: "فريقي", icon: "team", path: "/team" },
      { key: "journey", label: "الرحلات", icon: "journey", path: "/journeys" },
      { key: "assist", label: "المساعد", icon: "chat", path: "/assistant" },
    ],
  },
  {
    label: "السجلات والمتابعة",
    items: [
      { key: "leads", label: "الليدز", icon: "leads", path: "/leads" },
      { key: "student", label: "سجل الطلاب", icon: "student", path: "/students" },
      { key: "teacher", label: "سجل المعلمين", icon: "teacher", path: "/teachers" },
      { key: "performance", label: "الأداء", icon: "director", path: "/performance" },
    ],
  },
  {
    label: "مكاتب الأقسام",
    items: [
      { key: "eval", label: "التقييم والترشيح", icon: "eval", path: "/evaluation" },
      // ⚠️ بند مستقل مش تبويب جوّه التقييم: دعم الطلاب بيفتحه وهو في نص
      //    مكالمة مع ولي الأمر، ودفنه جوّه شاشة قسم تاني كان هيخلّيه
      //    ميزة محدش لاقيها.
      { key: "avail", label: "إتاحات التقييم", icon: "eval", path: "/evaluation/availability" },
      { key: "supervise", label: "الإشراف الإداري", icon: "shield", path: "/supervision" },
      { key: "hiring", label: "التوظيف والتدريب", icon: "hiring", path: "/hiring" },
      { key: "record", label: "التسجيلات", icon: "record", path: "/recordings" },
      { key: "accounts", label: "مكتب الحسابات", icon: "book", path: "/accounts" },
    ],
  },
  {
    label: "الإدارة",
    items: [
      { key: "director", label: "لوحة المدير", icon: "director", path: "/director" },
      { key: "access", label: "المستخدمون والصلاحيات", icon: "access", path: "/access" },
    ],
  },
];

export const NAV_ENTRIES: NavEntry[] = NAV_GROUPS.flatMap((g) => g.items);

/**
 * حارس ضد الكذب على الموظف.
 *
 * ⚠️ عنصر تنقّل مساره مش في `ROUTES` بيوقّع الموظف على «الصفحة دي مش
 *    موجودة» — والشاشة **موجودة ومعتمدة في التصميم**. العطل ده حصل فعلًا مع
 *    جرس الإشعارات. الفحص هنا بيصرخ في السجل ساعة ما يحصل الانفصال، مش بعد
 *    ما موظف يبلّغ عنه.
 */
/** بيخلّي الاستيراد حيًّا — الحارس نفسه بيصرخ عند التحميل */
export const CHIP_CLASH_COUNT = CHIP_NAME_CLASHES.length;

const orphanNavPaths = NAV_ENTRIES.filter((e) => !matchRoute(e.path)).map((e) => e.path);
if (orphanNavPaths.length > 0) {
  console.error(
    `[nav] عناصر تنقّل مالهاش مسار معرّف في ROUTES: ${orphanNavPaths.join(" · ")} —` +
      " العنصر ده هيوقّع الموظف على «الصفحة مش موجودة» وهي موجودة في التصميم.",
  );
}
